import { MbscCalendarEvent } from "@mobiscroll/react";
import { toLuxonDateTime } from "./validateEventUpdate.function";

export function updateMbscSchedulesTime(
  inputSchedules: MbscCalendarEvent[],
  newStartTime: string, // e.g., "08:00"
  newEndTime: string // e.g., "17:00"
): MbscCalendarEvent[] {
  return inputSchedules.map(schedule => {
    if (!schedule.start || !schedule.end) return [];

    const startDate = toLuxonDateTime(schedule.start);
    const endDate = toLuxonDateTime(schedule.end);

    const [startHour, startMinute] = newStartTime.split(":").map(Number);
    const [endHour, endMinute] = newEndTime.split(":").map(Number);

    return {
      ...schedule,
      start: startDate.set({ hour: startHour, minute: startMinute }).toJSDate(),
      end: endDate.set({ hour: endHour, minute: endMinute }).toJSDate()
    };
  });
}
